import { useTranslation } from "react-i18next"
import { useAppSelector } from "@/reducers/hooks"
import type * as React from "react"
import { useCallback, useContext } from "react"
import { getCMRJid } from "@/jidUtils"
import { XmppContext } from "@/stream/xmppClient"
import { useSidebar } from "./SidebarContext"
import { selectChatCounts } from "@/reducers/chatsSliceSelectors"
import { shallowEqual } from "react-redux"
import BaseSidebarButton from "./BaseSidebarButton"
import { selectTabs, TAB_TYPES } from "@/reducers/tabsSlice"
import { Files } from "lucide-react"
import { FilesIconActive } from "@/components/icons/FilesIcon"

const CMRSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const { myJid } = useContext(XmppContext)
  const { onActiveChatChange } = useSidebar()
  const { activeTab } = useAppSelector(selectTabs)
  const active = activeTab === TAB_TYPES.CMR

  const handleCMRClick = useCallback(() => {
    onActiveChatChange(getCMRJid(myJid))
  }, [onActiveChatChange, myJid])

  const chatCounts = useAppSelector(
    selectChatCounts(myJid.toString()),
    shallowEqual,
  )

  const cmrChatJid = getCMRJid(myJid)

  const unreadCMR = chatCounts[cmrChatJid] || 0

  const tooltipText =
    unreadCMR > 0
      ? t("app.sidebar.cmrDocumentsUnread", { unread: unreadCMR })
      : t("app.sidebar.cmrDocuments")

  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.CMR}
      icon={Files}
      activeIcon={FilesIconActive}
      tooltipText={tooltipText}
      className={className}
      onClick={handleCMRClick}
    >
      {!active && unreadCMR > 0 && (
        <div className="absolute right-[-3px] top-[-3px] flex h-4 min-w-4 items-center justify-center rounded-lg bg-base-primary p-1 text-[10px] font-semibold text-white">
          {unreadCMR}
        </div>
      )}
    </BaseSidebarButton>
  )
}

export default CMRSidebarButton
